import { guid } from '@Utility';

export default class Snackbar {
  static templateId;

  static elements = [];

  /**
   * All possible elements that a snackbar might contain.
   * Subclasses will define which elements it actually uses
   * by the static elements array
   */
  static elementMapping = {
    imageContainer: '.snackbar__image-container',
    image: '.snackbar__image',
    detailsContainer: '.snackbar__details',
    textContainer: '.snackbar__text',
    linkContainer: '.snackbar__link',
    buttonContainer: '.snackbar__button',
  };

  container;
  options;
  dismissable;
  id;

  constructor(options = {}) {
    this.options = options;
    this.id = options.id || guid();
    this.dismissable = options.dismissable || false;
    this.init();
  }

  prepare() {
    throw new TypeError(
      `Missing prepare() method from ${this.constructor.name} Snackbar`,
    );
  }

  show() {
    this.container.classList.add('snackbar--added');
  }

  dismount() {
    const closure = (res, rej) => {
      this.container.classList.add('snackbar--removed');

      this.container.addEventListener('transitionend', () => {
        res(this.container);
      });
    };

    return new Promise(closure);
  }

  isDismissable() {
    return this.dismissable;
  }

  getContainer() {
    return this.container;
  }

  addTo(htmlElement) {
    htmlElement.append(this.container);
  }

  init() {
    const { templateId, elements, elementMapping } = this.constructor;
    const template = document.getElementById(templateId);
    this.container = template.content.children[0].cloneNode(true);

    elements.forEach((element) => {
      const selector = elementMapping[element];
      this[element] = this.container.querySelector(selector);
    });
  }
}
